import { render, staticRenderFns } from "./bottom-sheet-header.vue?vue&type=template&id=32868c4b&scoped=true"
import script from "./bottom-sheet-header.vue?vue&type=script&lang=js"
export * from "./bottom-sheet-header.vue?vue&type=script&lang=js"
import style0 from "./bottom-sheet-header.vue?vue&type=style&index=0&id=32868c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32868c4b",
  null
  
)

export default component.exports